"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TERRITORIES = void 0;
exports.TERRITORIES = Object.freeze({
    UNITED_STATES: 'United States',
    UNITED_KINGDOM: 'United Kingdom',
});
